import Grid from '@mui/material/Grid'
import React, { useEffect } from "react";
import {
  useFormContext,
} from "react-hook-form";
import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";

import WSDateField from "../../Components/DateField/WSDateField";

interface CashInHandProps {
  id?: string;
}

const CashInHandWrapper: React.FC<CashInHandProps> = ({ id }) => {
  const methods = useFormContext();
  const { control, register, reset } = methods;

  useEffect(
    () => () => {
      reset();
    },
    [id, reset],
  );

  return (
    <>
      <Grid
        style={{
          paddingLeft: 5,
          paddingRight: 20,
          position: "relative",
          margin: 0,
          marginTop: "3rem",
        }}
        container
        spacing={2}
      >
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Enter Amount *"}
            {...register("amount")}
            id="amount"
            name="amount"
            control={control}
            rules={{ required: "Amount is required" }}
            type={TextType.Currency}
            currency={CurrencyType.Rupee}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSDateField
            id="adjustmentDate"
            name="adjustmentDate"
            label={"Adjustment Date"}
            dateFormat="DD-MM-YYYY"
            denyFuturOrPast="custom"
            control={control}
            rules={{ required: "Adjustment date is required" }}
          />
        </Grid>
        <Grid item xs={12}>
          <WSTextAreaField
            label={"Description"}
            id={"description"}
            name={"description"}
            control={control}
            rules={{ required: false }}
            rows={3}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CashInHandWrapper;
